/* eslint-disable jsx-a11y/anchor-is-valid */
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

//constants
//scss
import './DashboardPage.scss'
import {KTSVG, configData} from '../../../../_metronic/helpers'
import {useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {
  FrontendDashboardCalanderData,
  getFEdashboardCalander,
} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import moment from 'moment-timezone'
import {useEffect, useRef, useState} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {getIsDefaultRegion} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useGetReportCampaignQuery} from '../../../../services/cellcast.v3'
import {useInboxResponsive} from '../inbox-v2/useInboxResponsive'
import {storeReportId} from '../reports-analytics/reportSlices/reportAnalytics'

const ConfigDashboard = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const calendarRef: any = useRef(null)
  const calanderData = useSelector(getFEdashboardCalander)
  const [eventHoverInfo, setEventHoverInfo] = useState<any>(null)
  const [popupPosition, setPopupPosition] = useState({left: 0, top: 0})
  const popupRef = useRef<HTMLDivElement>(null)
  const [campType] = useState('sms')
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const {isMobile} = useInboxResponsive()
  useEffect(() => {
    dispatch(
      FrontendDashboardCalanderData({
        fromDate: moment(calendarRef.current.getApi()?.currentDataManager?.data?.currentDate)
          .startOf('month')
          .format('YYYY-MM-DD'),
        toDate: moment(calendarRef.current.getApi()?.currentDataManager?.data?.currentDate)
          .endOf('month')
          .format('YYYY-MM-DD'),
        camp_type: campType,
      })
    )
  }, [campType, dispatch])

  const RecentCampaignUs = useGetReportCampaignQuery(
    {
      campType: campType,
      fromDate: moment(calendarRef.current?.getApi()?.currentDataManager?.data?.currentDate)
        .startOf('month')
        .format('YYYY-MM-DD'),
      toDate: moment(calendarRef.current?.getApi()?.currentDataManager?.data?.currentDate)
        .endOf('month')
        .format('YYYY-MM-DD'),
      limit: 100,
      page: 1,
      sort_key: 'created_at',
      sort_value: 'desc',
    },
    {
      skip: isDefaultRegion,
    }
  )

  const calendarEvents = () => {
    if (isDefaultRegion) {
      return calanderData?.map((event: any) => ({
        id: event._id,
        title: event.name,
        color: event.camp_type === 'sms' ? '#00BA341A' : '#0085FF1A',
        textColor: event.camp_type === 'sms' ? '#00BA34' : '#0085FF',
        date: moment(event.scheduleAt || event.createdAt).format('YYYY-MM-DD'),
        extendedProps: {
          description: moment(event.scheduleAt || event.createdAt).format('LLL'),
          message: event.message,
          campType: event.camp_type,
          recipients: event.recipients,
          creditAmount: event.creditAmount,
        },
      }))
    } else {
      return RecentCampaignUs?.data?.data?.items?.map((key: any) => ({
        id: key?._id,
        title: key?.name,
        date: moment(key?.scheduleAt || key?.createdAt)?.format('YYYY-MM-DD'),
        description: moment(key?.scheduleAt || key?.createdAt)?.format('LLL'),
        message: key?.message,
        campType: key?.type,
      }))
    }
  }

  const handleEventClick = (info: any) => {
    const cursorX = info.jsEvent.clientX
    const cursorY = info.jsEvent.clientY
    const popupWidth = 50
    const popupHeight = 300
    const offset = 10
    const screenWidth = window.innerWidth

    const left =
      cursorX + popupWidth + offset > screenWidth ? cursorX - popupWidth - offset : cursorX + offset

    let top = cursorY - popupHeight - offset
    if (top < 0) {
      top = cursorY + offset
    }

    setPopupPosition({left, top})

    let eventDetails = null
    if (isDefaultRegion) {
      eventDetails = calanderData?.find((event: any) => event._id === info.event.id)
    } else {
      const item = RecentCampaignUs?.data?.data?.items?.find((i: any) => i._id === info.event.id)
      if (item) {
        eventDetails = {...item, camp_type: item.type || item.camp_type}
      }
    }
    setEventHoverInfo(eventDetails || null)
  }

  const handleClose = () => {
    setEventHoverInfo(null)
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setEventHoverInfo(null)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleStoreReportId = (id: any, campType: string, data: any) => {
    dispatch(
      storeReportId({
        id: id,
        camp_type: campType,
        data: data,
      })
    )
  }

  return (
    <>
      <div className='d-flex flex-row calender_wrapper mobile-layout'>
        <div className='col-lg-9 py-6 calender-main'>
          <div className='card'>
            <div className='card-header border-botton-1  pt-5 pb-4'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-4 mb-1'>Calendar</span>
              </h3>
              <div className='card-toolbar'>
                {/* <WSSelect
                  value={campType}
                  onChange={(e: any) => setCampType(e.value)}
                  placeholder='All campaigns'
                  options={options}
                  className='w-150px me-4'
                /> */}
                {/* <span className='btn btn-sm btn-primary py-3 px-5'>New message</span> */}
              </div>
            </div>
            <div className='card-body'>
              <div className='calender-style '>
                <FullCalendar
                  ref={calendarRef}
                  headerToolbar={{
                    start: 'prevButton', // will normally be on the left. if RTL, will be on the right
                    center: 'title',
                    end: 'nextButton', // will normally be on the right. if RTL, will be on the left
                  }}
                  customButtons={{
                    nextButton: {
                      text: ``,
                      click: (e: any) => {
                        let calendarApi = calendarRef.current.getApi()
                        dispatch(
                          FrontendDashboardCalanderData({
                            fromDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                              .add(1, 'month')
                              .startOf('month')
                              .format('YYYY-MM-DD'),
                            toDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                              .add(1, 'month')
                              .endOf('month')
                              .format('YYYY-MM-DD'),
                            camp_type: campType,
                          })
                        )
                        calendarApi.next()
                      },
                      icon: 'chevron-right',
                    },
                    prevButton: {
                      text: '',
                      click: (e: any) => {
                        let calendarApi = calendarRef.current.getApi()
                        dispatch(
                          FrontendDashboardCalanderData({
                            fromDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                              .subtract(1, 'month')
                              .startOf('month')
                              .format('YYYY-MM-DD'),
                            toDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                              .subtract(1, 'month')
                              .endOf('month')
                              .format('YYYY-MM-DD'),
                            camp_type: campType,
                          })
                        )
                        calendarApi.prev()
                      },
                      icon: 'chevron-left',
                    },
                  }}
                  // eventMouseEnter={handleEventMouseEnter}
                  eventClick={handleEventClick}
                  // eventMouseLeave={handleEventMouseLeave}
                  plugins={[dayGridPlugin]}
                  initialView='dayGridMonth'
                  events={calendarEvents()}
                />
              </div>
              {eventHoverInfo && (
                <div
                  className='pro-popup'
                  ref={popupRef}
                  style={{left: popupPosition.left, top: popupPosition.top}}
                >
                  <div className='d-flex justify-content-end position-absolute top-0 end-0 p-4'>
                    <div className='cursor-pointer' onClick={handleClose}>
                      <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                    </div>
                  </div>
                  <h3
                    className='title-1'
                    style={{
                      color:
                        (eventHoverInfo.camp_type || eventHoverInfo.type) === 'sms'
                          ? '#74CA8F'
                          : '#0085FF',
                    }}
                  >
                    {(eventHoverInfo.camp_type || eventHoverInfo.type || '').toUpperCase()}
                    {eventHoverInfo.scheduleAt && new Date(eventHoverInfo.scheduleAt) > new Date() && (
                      <span
                        className='badge ms-2'
                        style={{
                          display: 'inline-block',
                          width: '68px',
                          height: '21px',
                          borderRadius: '4px',
                          padding: '4px 8px',
                          fontSize: '10px',
                          fontWeight: '600',
                          lineHeight: '13px',
                          letterSpacing: '-3%',
                          textAlign: 'left',
                          background: '#F53B6E1F',
                          color: '#7950F2',
                        }}
                      >
                        {'Scheduled'}
                      </span>
                    )}
                  </h3>
                  <h2 className='mb-3 title-2'>{eventHoverInfo.name || eventHoverInfo.title}</h2>
                  <div className='d-flex justify-content-between mb-3'>
                    <div className='d-flex gap-1'>
                      <label className='label'>Sent: </label>
                      <span>
                        {eventHoverInfo.createdAt
                          ? moment(eventHoverInfo.createdAt).format('DD/MM/YYYY HH:mm')
                          : '-'}
                      </span>
                    </div>
                    <div className='d-flex text-end gap-1'>
                      <label className='label'>Number of Recipients:</label>
                      <span>{eventHoverInfo.recipients || 0}</span>
                    </div>
                  </div>
                  <div className='d-flex flex-column gap-1 mb-2'>
                    <label className='label'>Message Content: </label>
                    <span
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        lineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {eventHoverInfo.message || '-'}
                    </span>
                  </div>
                  <div className='d-flex mt-6'>
                    <Link
                      to='/eofy/snapshot'
                      target='_blank'
                      onClick={() =>
                        handleStoreReportId(
                          eventHoverInfo._id,
                          eventHoverInfo.camp_type || eventHoverInfo.type,
                          eventHoverInfo
                        )
                      }
                    >
                      <label className='button-label'>View Report</label>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='col-lg-3 p-1 mt-5'>
          <div className={`card ${isMobile ? '' : 'w-300px'}`}>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-4 mb-1'>Configurations</span>
                <span className='text-muted fw-light fs-8'>Integrations, API and more</span>
              </h3>
            </div>
            <div className='card-body'>
              {isDefaultRegion ? (
                <div>
                  {configData?.map((data, idx) => (
                    <div className='row mb-5' key={idx}>
                      <div className='col-10'>
                        <h3 className='card-title d-flex align-items-start flex-column'>
                          <span className='card-label fw-bolder fs-6'>{data.title}</span>
                        </h3>
                        <span className='text-muted fw-light fs-8 w-100px'>{data.description}</span>
                      </div>
                      <div className='col-2 d-flex flex-end p-1'>
                        <OverlayTrigger
                          placement='bottom'
                          overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
                        >
                          <a
                            onClick={() => navigate(data?.path)}
                            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                          >
                            <KTSVG
                              path='/media/icons/duotune/arrows/arr064.svg'
                              className='svg-icon-2'
                            />
                          </a>
                        </OverlayTrigger>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className='text-center'>
                  <h3 className='text-muted fw-light'>Coming Soon</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConfigDashboard
